import { c as _c } from "react/compiler-runtime";
import { IcoSpeedometer24 } from '@onefootprint/icons';
import type { FakeImageScore } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { TransformedDocument } from '@/components/entities/components/details/hooks/use-documents';
import useDocumentUploadSideText from '@/entity/hooks/use-document-upload-side-text';
import CollapsibleSection from '../collapsible-section';
import useAiImageScoresVisible from './use-ai-image-scores-visible';
type AiImageScoresProps = {
  uploads: TransformedDocument['uploads'];
};
const FEATURES = ['aiGenerated', 'templateRender', 'screenRecapture', 'manualTamper', 'syntheticRisk'] as const;
const AiImageScores = t0 => {
  const $ = _c(20);
  const {
    uploads
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.aiImageScores"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const sideT = useDocumentUploadSideText();
  const scoredUploads = uploads.filter(_temp).map(_temp2).filter(_temp3);
  let t2;
  if ($[1] !== t) {
    t2 = value => value === undefined ? t(_temp4) : t(_temp5, {
      value: Math.round(value * 100)
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const percent = t2;
  let t3;
  if ($[3] !== percent || $[4] !== t) {
    t3 = model => model ? t(_temp6, {
      score: percent(model.score),
      verdict: t($_2 => $_2.verdict[model.verdict])
    }) : percent(undefined);
    $[3] = percent;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const scoreText = t3;
  const isVisible = useAiImageScoresVisible(scoredUploads.length > 0);
  if (scoredUploads.length === 0 || !isVisible) {
    return null;
  }
  const T0 = CollapsibleSection;
  const t4 = IcoSpeedometer24;
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp7);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = true;
  const t7 = "flex flex-col gap-4 w-full";
  let t8;
  if ($[8] !== percent || $[9] !== scoreText || $[10] !== sideT || $[11] !== t) {
    t8 = t9 => {
      const {
        side: side_0,
        openai: openai_0,
        jev: jev_0
      } = t9;
      return <table key={side_0} className="w-full text-body-2 tabular-nums"><thead><tr className="text-label-2"><th className="text-left text-primary">{sideT(side_0)}</th><th className="w-28 text-right text-secondary">{t(_temp8)}</th><th className="w-28 text-right text-secondary">{t(_temp9)}</th></tr></thead><tbody className="text-secondary"><tr><td>{t(_temp10)}</td><td className="text-right">{scoreText(openai_0)}</td><td className="text-right">{scoreText(jev_0)}</td></tr>{FEATURES.map(feature => <tr key={feature} className="text-tertiary"><td>{t($_7 => $_7.features[feature])}</td><td className="text-right">{percent(openai_0?.[feature])}</td><td className="text-right">{percent(jev_0?.[feature])}</td></tr>)}</tbody></table>;
    };
    $[8] = percent;
    $[9] = scoreText;
    $[10] = sideT;
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = scoredUploads.map(t8);
  let t10;
  if ($[13] !== t9) {
    t10 = <div className={t7}>{t9}</div>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== T0 || $[16] !== t10 || $[17] !== t4 || $[18] !== t5) {
    t11 = <T0 icon={t4} title={t5} defaultOpen={t6}>{t10}</T0>;
    $[15] = T0;
    $[16] = t10;
    $[17] = t4;
    $[18] = t5;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};
export default AiImageScores;
function _temp(t0) {
  const {
    isLatest
  } = t0;
  return isLatest;
}
function _temp2(t0) {
  const {
    side,
    experiment
  } = t0;
  return {
    side,
    ...experiment?.aiImageScore
  };
}
function _temp3(t0) {
  const {
    openai,
    jev
  } = t0;
  return openai || jev;
}
function _temp4($) {
  return $.notScored;
}
function _temp5($_0) {
  return $_0.percent;
}
function _temp6($_1) {
  return $_1.score;
}
function _temp7($_3) {
  return $_3.title;
}
function _temp8($_4) {
  return $_4.openai;
}
function _temp9($_5) {
  return $_5.jev;
}
function _temp10($_6) {
  return $_6.overall;
}